import validator from 'validator';

const E_EMPTY_TOKEN = 'You must provide a token';
const E_PROVIDER_NOT_SET = 'You must select a provider';

const isEmpty = (value) => validator.isEmpty(value, { ignore_whitespace: true });

export const validate = (values) => {
  var errors = {};

  if (isEmpty(values.token || '')) {
    errors.token = E_EMPTY_TOKEN;
  }

  if (isEmpty(values.type || '')) {
    errors.type = E_PROVIDER_NOT_SET;
  }

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
